import Dialog from "dialog";
import template from "../html/dialog-config-airflow.html";
import css from "../css/dialog-config-airflow.css";

class ConfigAirFlowDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-airflow", ConfigAirFlowDialog);
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});
    this.spinnerMLM.value = this.textboxValue.value;
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }
  constructor() {
    super();

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.airflow.id;
    this.textboxSerialNumber.value = devices.airflow.serialNumber;
    this.textboxDeviceStatus.value = devices.airflow.status;
    this.textboxValue.value = devices.airflow.value;
    this.textboxSelectedFluidName.value = devices.airflow.selectedFluidName;
  }
  spinnerMLM_change(event) {
    server.rcall("RM_AirFlow_setMLM", this.spinnerMLM.value).catch(function(result) {
      alert(result);
    });
  }
  async buttonWink_click() {
    await server.rcall("RM_AirFlow_wink");
  }
  buttonClose_click(event) {
    this.close();
  }
  close() {
    super.close();
  }
}

ConfigAirFlowDialog.constructor();

export default ConfigAirFlowDialog;